const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900 flex items-center justify-center z-50">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-dark-700 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-rose-500 rounded-full border-t-transparent animate-spin"></div>
        </div>
        <p className="text-gray-400 text-sm font-medium">Yükleniyor...</p>
      </div>
    </div>
  );
};

export default FullPageLoader;
